/**
 * Utility function to get the API base URL
 * Uses the same logic as ApiService to ensure consistency
 * 
 * Priority:
 * 1. window.__API_URL__ (runtime injection)
 * 2. VITE_API_URL (build-time env var)
 * 3. Auto-detect from hostname (run.app = production)
 * 4. Fallback to localhost for development
 */
export const getApiBaseUrl = (): string => {
  // Check runtime injection first (highest priority)
  if ((window as any).__API_URL__) {
    return (window as any).__API_URL__;
  }
  
  // Check build-time environment variable
  if (import.meta.env.VITE_API_URL) {
    return import.meta.env.VITE_API_URL;
  }
  
  // Auto-detect production environment
  if (window.location.hostname.includes('run.app')) {
    return 'https://backend-real-auth-344710332118.us-central1.run.app';
  }
  
  // Fallback to localhost for local development
  return 'http://localhost:8000';
};






